module.exports = __webpack_public_path__ + "media/images/akka-image-e2b162b991a892b51ab0aab9b6aef5b4.jpg";